import React from 'react';
import { Budget, BudgetItem } from './BudgetItem';

export function BudgetList({
  budgets,
  onAddClick,
  selectedYear,
  selectedMonth,
  onBudgetClick
}: {
  budgets: Budget[];
  onAddClick: (budget: Budget) => void;
  selectedYear?: number;
  selectedMonth?: number;
  onBudgetClick?: () => void;
}) {
  return (
    <div className="flex flex-col gap-4">
      {budgets.map(budget => (
        <BudgetItem
          key={budget.id}
          budget={budget}
          onAddClick={onAddClick}
          selectedYear={selectedYear}
          selectedMonth={selectedMonth}
          onBudgetClick={onBudgetClick}
        />
      ))}
    </div>
  );
} 